import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { portfolioData } from "../../data/portfolioData";

const SITE_URL = "https://www.techzoneuae.com";

const allPortfolio = [
  { slug: "website-projects", title: "Website Projects", icon: "fa fa-laptop" },
  { slug: "mobile-apps", title: "Mobile Apps", icon: "fa fa-mobile-alt" },
  { slug: "software-solutions", title: "Software Solutions", icon: "fa fa-desktop" }
];

export default function PortfolioPage({ slug }) {
  const portfolio = portfolioData[slug];

  if (!portfolio) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h1>Portfolio Not Found</h1>
        <p>The requested portfolio does not exist.</p>
        <Link to="/">Back to Home</Link>
      </div>
    );
  }

  const canonical = `${SITE_URL}/portfolio/${slug}`;
  const desc = portfolio.overview.substring(0, 160);
  const ogTitle = `${portfolio.title} — Tech Zone FZC Dubai`;

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (typeof window.AOS !== "undefined") {
        window.AOS.init({ easing: "ease-in-out-sine" });
      }
      
      // Initialize GLightbox for gallery items if available
      if (typeof window.GLightbox !== "undefined" && window.$ && window.$(".btn_gallery").length) {
        window.GLightbox({ selector: ".btn_gallery" });
      }
    }
  }, [slug]);

  return (
    <>
      <Helmet>
        <title>{portfolio.title} — Tech Zone FZC Dubai</title>
        <meta name="description" content={desc} />
        <meta name="keywords" content={`${portfolio.title} Dubai, IT portfolio UAE`} />
        <link rel="canonical" href={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AE" />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="Tech Zone FZC" />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={`${SITE_URL}/assets/images/og-image.jpg`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={`${SITE_URL}/assets/images/og-image.jpg`} />
      </Helmet>

      {/* ============ PAGE HERO ============ */}
      <section
        className="page-hero"
        style={{ backgroundImage: `url('${portfolio.heroBg}')` }}
      >
        <div className="page-hero-overlay"></div>
        <div className="container">
          <div className="page-hero-content">
            <h1 className="page-title">{portfolio.title}</h1>
            <nav className="breadcrumb-nav">
              <Link to="/">Home</Link>
              <span className="sep">/</span>
              <Link to="/#portfolio">Portfolio</Link>
              <span className="sep">/</span>
              <span className="current">{portfolio.title}</span>
            </nav>
          </div>
        </div>
      </section>

      {/* ============ OVERVIEW & SIDEBAR SECTION ============ */}
      <section className="service-overview-section pt-60 pb-60">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-lg-8 mb-4 mb-lg-0" data-aos="fade-right" data-aos-delay="100">
              <div className="subtitle subtitle_1bececf" style={{ marginBottom: '12px' }}>
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">Our Portfolio</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
              <div className="title title_1bececf" style={{ marginBottom: '16px' }}>
                <h2>
                  <span></span>
                  <span>{portfolio.title}</span>
                  <span></span>
                </h2>
              </div>
              <p style={{ color: '#555', fontSize: '1.05rem', lineHeight: '1.8' }}>
                {portfolio.overview}
              </p>
            </div>

            <div className="col-lg-4" data-aos="fade-left" data-aos-delay="200">
              <div className="services-sidebar-widget">
                <div className="ssw-header">
                  <h3>
                    <i className="fa fa-folder-open" style={{ marginRight: '8px', color: 'var(--color-primary, #2400A8)' }}></i>
                    All Categories
                  </h3>
                </div>
                <ul className="ssw-list">
                  {allPortfolio.map((p) => (
                    <li key={p.slug}>
                      <Link
                        to={`/portfolio/${p.slug}`}
                        className={p.slug === slug ? 'active' : ''}
                      >
                        <i className={`fa ${p.icon}`}></i>
                        {p.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ GALLERY SECTION ============ */}
      <section className="tab-gallery-1 pt-60 pb-60" style={{ backgroundColor: "#f9f9f9" }}>
        <div className="container">
          <div className="row">
            {portfolio.projects.map((proj, idx) => (
              <div key={idx} className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay={100 * (idx + 1)}>
                <div className="portfolio-card-premium">
                  <img src={proj.image} alt={proj.title} className="portfolio-card-img" />
                  <a href={proj.image} className="portfolio-btn btn_gallery">
                    <i className="fa fa-plus"></i>
                  </a>
                  <div className="portfolio-card-overlay">
                    <span className="portfolio-cat">{proj.category}</span>
                    <h3 className="portfolio-title">{proj.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      <style dangerouslySetInnerHTML={{__html: `
        .portfolio-card-premium {
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.06);
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          background: #000;
          cursor: pointer;
          height: 350px;
          display: block;
        }
        .portfolio-card-premium:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.12);
        }
        .portfolio-card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
          opacity: 0.9;
        }
        .portfolio-card-premium:hover .portfolio-card-img {
          transform: scale(1.08);
          opacity: 1;
        }
        .portfolio-card-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 40px 25px 25px;
          background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%);
          color: #fff;
          transition: padding 0.4s ease;
        }
        .portfolio-card-premium:hover .portfolio-card-overlay {
          padding-bottom: 35px;
        }
        .portfolio-cat {
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          color: #f7a928; /* Gold accent color to match site CTA */
          margin-bottom: 10px;
          font-weight: 600;
          display: block;
        }
        .portfolio-title {
          font-size: 1.4rem;
          font-weight: 700;
          margin: 0;
          color: #fff;
          line-height: 1.3;
        }
        .portfolio-btn {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 45px;
          height: 45px;
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 1.1rem;
          opacity: 0;
          transform: scale(0.8) rotate(-45deg);
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          text-decoration: none;
        }
        .portfolio-card-premium:hover .portfolio-btn {
          opacity: 1;
          transform: scale(1) rotate(0deg);
          background: var(--color-primary, #2400A8);
          color: #fff;
        }
      `}} />

      {/* ============ CTA SECTION ============ */}
      <section className="service-cta-sec">
        <div className="container" data-aos="fade-up">
          <h2>Ready to Build Something Amazing?</h2>
          <p>Contact us today for a free consultation.</p>
          <Link to="/contact" className="btn-cta-gold">Get in Touch</Link>
          <a href="tel:+971502424117" className="btn-cta-outline-white">
            <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>
            +971 50 24 24 117
          </a>
        </div>
      </section>
    </>
  );
}
